


















import Vue from 'vue';
import { mapState } from 'vuex';
import { HubToast } from '@/components/HubComponents';

export default Vue.extend({
  name: 'AppToastArea',
  components: { HubToast },
  computed: { ...mapState('notification', ['notifications']) },
});
